import { render, staticRenderFns } from "./majorInfo.vue?vue&type=template&id=70083337&scoped=true&"
import script from "./majorInfo.vue?vue&type=script&lang=js&"
export * from "./majorInfo.vue?vue&type=script&lang=js&"
import style0 from "./majorInfo.vue?vue&type=style&index=0&id=70083337&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70083337",
  null
  
)

export default component.exports